module.exports = __webpack_public_path__ + "static/media/Header-BG@1x.b6416825.jpg";